__turbopack_context__.v({
  "active": "Q_DGka_active",
  "dot": "Q_DGka_dot",
  "dotContainer": "Q_DGka_dotContainer",
  "inArticleNav": "Q_DGka_inArticleNav",
  "line": "Q_DGka_line",
  "lineContainer": "Q_DGka_lineContainer",
  "linksContainer": "Q_DGka_linksContainer",
  "nav": "Q_DGka_nav",
  "navItem": "Q_DGka_navItem",
  "navItems": "Q_DGka_navItems",
  "navLabel": "Q_DGka_navLabel",
  "navTitle": "Q_DGka_navTitle",
});
